import React from 'react'
import { Attachment } from '../../types/messages'
import { formatFileSize, getFileIcon } from '../../utils/formatHelpers'

interface AttachmentItemProps {
  attachment: Attachment
  onDownload: (attachment: Attachment) => void
  showRemoveButton?: boolean
  onRemove?: () => void
  isDarkBackground?: boolean
}

const AttachmentItem = ({
  attachment,
  onDownload,
  showRemoveButton = false,
  onRemove,
  isDarkBackground = false
}: AttachmentItemProps) => {
  const textColor = isDarkBackground ? 'tw-text-sky-50' : 'tw-text-slate-700 dark:tw-text-slate-200'
  const mutedTextColor = isDarkBackground ? 'tw-text-sky-200' : 'tw-text-slate-500 dark:tw-text-slate-400'
  const iconColor = isDarkBackground ? 'tw-text-sky-100' : 'tw-text-sky-600 dark:tw-text-sky-300'
  const buttonIconColor = isDarkBackground ? 'tw-text-sky-100 hover:tw-text-white' : 'tw-text-sky-600 hover:tw-text-sky-700 dark:tw-text-sky-300 dark:hover:tw-text-sky-100'

  return (
    <div
      className={`
        tw-p-1 tw-rounded-md tw-flex tw-items-center tw-gap-x-2 
      `}
    >
      <div className={`tw-flex-shrink-0 ${iconColor}`}>
        <i className={`fa ${getFileIcon(attachment.type)} tw-text-lg`} />
      </div>
      <div className='tw-flex-grow tw-min-w-0'>
        <p
          className={`tw-text-sm tw-font-medium tw-truncate ${textColor}`}
          title={attachment.name}
        >
          {attachment.name}
        </p>
        <small className={`tw-text-xs ${mutedTextColor}`}>
          {formatFileSize(attachment.size)}
        </small>
      </div>
      <div className='tw-flex-shrink-0'>
        {showRemoveButton && (onRemove != null)
          ? (
            <button
              type='button'
              className='tw-p-1 tw-text-red-500 hover:tw-text-red-700 hover:tw-bg-red-100 dark:hover:tw-bg-red-900/50 tw-rounded-full focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-red-500'
              onClick={onRemove}
              aria-label='Usuń załącznik'
            >
              <i className='fa fa-times tw-text-sm' />
            </button>
            )
          : (
            <button
              type='button'
              className={`tw-p-1.5 ${buttonIconColor} hover:tw-bg-black/10 dark:hover:tw-bg-white/10 tw-rounded-md focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-sky-500`}
              onClick={() => onDownload(attachment)}
              aria-label='Pobierz załącznik'
            >
              <i className='fa fa-download tw-text-base' />
            </button>
            )}
      </div>
    </div>
  )
}

export default AttachmentItem
